import { useEffect } from 'react';
import { applyDocumentLanguage } from '@/app/language';

/**
 * SC-1752 — the survey sets <html lang/dir> for ITS language without touching
 * the site's persisted choice (`LANG_STORAGE_KEY`) or i18n's global language,
 * and gives back whatever was there when the guest leaves the page.
 */
export function useDocumentLanguage(lang: string, title?: string): void {
  useEffect(() => {
    const el = document.documentElement;
    const previous = { lang: el.lang, dir: el.dir, title: document.title };
    return () => {
      el.lang = previous.lang;
      el.dir = previous.dir;
      document.title = previous.title;
    };
  }, []);
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
  useEffect(() => {
    applyDocumentLanguage(lang);
  }, [lang]);
}
